import { PaginationTypes } from 'types/sharedResponse'

export const GET_EXISTING_CANDIDATES = 'GET_EXISTING_CANDIDATES'
export const GET_EXISTING_CANDIDATES_PENDING = 'GET_EXISTING_CANDIDATES_PENDING'
export const GET_EXISTING_CANDIDATES_FULFILLED = 'GET_EXISTING_CANDIDATES_FULFILLED'
export const GET_EXISTING_CANDIDATES_REJECTED = 'GET_EXISTING_CANDIDATES_REJECTED'

export type Candidate = {
  id: number
  name_i18n: string
}

export type GetCandidatesResponse = {
  data: {
    candidates: Candidate[]
  }
  pagination?: PaginationTypes
  success?: boolean
  statusCode?: number
}
